/**
 * Copyright ToolBelt Data Inc., 2021 All Rights Reserved
 */

import styled from "styled-components";

const Panel = styled.div `
  box-shadow: rgba(0, 0, 0, 0.05) 0 1px 2px 0, rgba(0, 0, 0, 0.03) 0 1px 3px 1px;
  padding: 1rem;
  margin-top: 1.5rem;
  background-color: #ffffff;
`;

export default Panel;
